<template>
  <div class="pie-chart">
    <header>
      <h3>{{ title }}</h3>
      <span>{{ subTitle }}</span>
    </header>
    <div ref="target" style="width: 100%" :style="{ height }"></div>
  </div>
</template>
<script>
import * as echarts from "echarts"

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "300px",
    },
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    }
  },

  mounted() {
    this.myChart = echarts.init(this.$refs.target)
    this.renderChart()
    window.addEventListener("resize", this.handleResize)
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize)
    this.myChart && this.myChart.dispose()
  },

  methods: {
    renderChart() {
      const options = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        // legend: {
        //   orient: "vertical",
        //   left: 10,
        //   top: "center",
        //   width: 120, // 固定图例宽度
        //   itemWidth: 30, // 固定每项宽度
        //   type: "scroll", // 支持滚动
        //   pageButtonShow: false, // 隐藏翻页按钮
        //   formatter: (name) => {
        //     // 文字过长时自动截断
        //     if (name.length > 8) {
        //       return name.substring(0, 8) + '...';
        //     }
        //     return name;
        //   },
        //   data: this.dataList.map((item) => item.name),
        // },
        series: [
          {
            name: this.title,
            type: "pie",
            radius: ["20%", "80%"],
            center: ["50%", "50%"],
            roseType: "radius", // 修改为radius，使数值与面积成正比
            itemStyle: {
              borderRadius: 8,
            },
            label: {
              formatter: "{b}: {c}",
              distance: 10, // 标签与图形的距离
              show: true,
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "16",
                fontWeight: "bold",
              },
            },
            data: this.dataList.map((item) => ({
              name: item.name,
              value: item.num,
            })),
          },
        ],
      }
      this.myChart && this.myChart.setOption(options)
    },

    handleResize() {
      this.myChart && this.myChart.resize()
    },
  },
  watch: {
    dataList: {
      handler(newVal, oldVal) {
        this.renderChart()
      },
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss">
.pie-chart {
  width: 100%;
  height: 100%;
  header {
    display: flex;
    align-items: center;
    span {
      color: #a9afb9;
      margin-left: 10px;
    }
  }
}
</style>
